<template>
  <div>
    <PageTitle v-bind:title="'Writing types'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button variant="primary" size="sm" :disabled="!$store.getters.checkRole('legam.bib.writingtype.add')" class="float-right mb-4" v-b-modal.modal-new-writingtype v-if="config.editable">
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new writing type
          </b-button>
          <b-modal id="modal-new-writingtype" title="New writing type" ok-title="Save" @ok="saveWritingtype" size="lg">
            <WritingtypeNewEdit />
          </b-modal>
          <LegamDataTables v-if="config.editable" v-bind="$data" />
          <LegamDataTablesClientSide
            v-else
            v-bind="$data"
            @click="openDetails"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
  * >>> .tdAction {
    width: 150px;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import router from '@/router'
  import PageTitle from '@/components/PageTitle.vue'
  import LegamDataTables from '@/components/LegamDataTables.vue'
  import LegamDataTablesClientSide from '@/components/LegamDataTablesClientSide.vue'
  import tdColAction from "@/components/tdColAction";
  import tdColSafeHTML from "@/components/tdColSafeHTML"
  import WritingtypeNewEdit from "@/components/Bibliography/WritingtypeNewEdit"
  import HelpStore from '@/store/helpstore.js'
  import tdColUUID from "@/components/tdColUUID"
  import config from '@/config.js'

  export default {
    name: 'WritingtypeAuthors',
    data(){
      return {
        columns: [
          { title: 'ID', field: 'id', sortable: true, searchable: true, tdComp: tdColUUID },
          { title: 'Type', field: 'type', sortable: true, searchable: true },
          { title: 'Comment', field: 'comment', sortable: true, tdComp: tdColSafeHTML, searchable: true },
          { title: 'Action', field: 'id', tdComp: tdColAction, thClass: 'tdAction',
            transformData: function (row) {
              return [
                { text: null, icon: 'list-ul', id: row.id, to: {
                  name: 'WritingtypeDetails',
                  params: {
                    id: row.id
                  }}
                }
              ]
            }
          }
        ],
        columnsPI: [
          { title: 'Type', field: 'type', sortable: true, searchable: true },
          { title: 'Comment', field: 'comment', sortable: true, tdComp: tdColSafeHTML, searchable: true }
        ],
        url: '/writingtypes/datatables',
        key: 1,
        searchableByColumn: true,
        config: config,
      }
    },
    computed: {
      ...mapState({
        userSettings: state => state.user.settings
      }),
    },
    components: {
      PageTitle,
      LegamDataTables,
      LegamDataTablesClientSide,
      WritingtypeNewEdit
    },
    methods: {
      saveWritingtype(){
        this.$store.dispatch('createWritingtype', HelpStore.item).then((response) => {
          router.push(`/writingtype/${response.data.id}`)
        })
      },
      openDetails(data) {
        router.push(`/writingtype/${data.id}`)
      },
    },
    watch: {
      "userSettings"(){
        this.key++
      }
    }
  }
</script>
